import React from 'react';

import { Dimmer, Loader } from 'semantic-ui-react';

const Loading = () => {
    return (
        <div><Dimmer><Loader /></Dimmer></div>
    )
}

export default Loading;